<template>
  <b-container class="main-container">
    <div v-show="isImportShow">
      <slot> </slot>
      <div>
        <p class="text-danger text-center" v-html="this.errorMsg"></p>
      </div>
      <div
        :class="[{ '-drag': isDrag == 'new' }, 'upload_area']"
        @dragover.prevent="checkDrag($event, 'new', true)"
        @dragleave.prevent="checkDrag($event, 'new', false)"
        @drop.prevent="onDrop"
      >
        <div class="drop">
          <img
            src="../../assets/images/file_upload_icon.svg"
            alt="アップロードアイコン"
          />
          <p class="drag-drop-info">
            ドラッグ＆ドロップしてファイルをアップロードしてください
          </p>
          <p class="text_black mb-3">または</p>
          <p v-show="!isShow()">
            <small class="text_blue"
              >Shiftキーを押しながらファイルを複数選択可能</small
            >
          </p>
          <p v-show="isShow()" class="small">
            <label for="corporation_file" class="blue-link upload_btn">
              <strong>ファイルを選択</strong>
              <input
                type="file"
                class="drop__input"
                style="display: none"
                id="corporation_file"
                :accept="accept"
                @change="onDrop"
              />
            </label>
          </p>
        </div>
      </div>
    </div>
    <div v-show="!isImportShow">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
      <cropper
        ref="cropper"
        :src="image.src"
        :stencil-component="$options.components.Stencil"
      />
      <b-container class="d-flex justify-content-between pt-5">
        <b-button class="btn-blue" @click="cancel">キャンセル</b-button>
        <b-button class="btn-blue btn_blue crop-img-button" @click="crop">OK</b-button>
      </b-container>
    </div>
  </b-container>
</template>

<script>
import { Cropper, Preview } from 'vue-advanced-cropper'
import Stencil from './StencilComponent.vue'
import Loading from 'vue-loading-overlay'
import 'vue-advanced-cropper/dist/style.css'
import AppConstants from '../../constants/app.constants'
import EventBus from '../../mixins/EventBus'
export default {
  props: {
    accept: {
      type: String,
      default: AppConstants.AVATAR_ACCEPT_TYPES
    }
  },
  data() {
    return {
      isDrag: null,
      errorMsg: null,
      isImportShow: true,
      image: {
        src: null,
        type: null
      },
      isLoading: false,
      isCropping: false
    }
  },
  components: {
    Cropper,
    Preview,
    Loading,
    Stencil
  },
  mounted() {},

  methods: {
    checkMoving(event) {
      this.$emit('no-close-modal', event)
      this.isCropping = event
    },
    isShow() {
      return true
    },
    checkDrag(event, key, status) {
      if (status && event.dataTransfer.types === 'Files') {
        return false
      }
      this.isDrag = status ? key : null
    },
    onDrop(event, key = '', image = {}) {
      this.isDrag = null
      // ①ファイル取得
      let fileList = event.target.files
        ? event.target.files
        : event.dataTransfer.files
      // ファイルが無い時は処理を中止
      if (fileList.length === 0) {
        return false
      } else if (fileList.length === 1) {
        try {
          this.isLoading = true
          const extensionFile = fileList[0].name.split('.').pop()
          // Check extension file
          if (AppConstants.AVATAR_ACCEPT_EXTENTION_TYPES.includes(extensionFile.toLowerCase())) {
            // Check images are over than 10MB
            if (fileList[0].size / 1024 / 1024 > 10) {
              this.$emit('cropping-flag', true)
              let reader = new FileReader()
              reader.readAsDataURL(fileList[0])
              reader.onload = (event) => {
                let imageUrl = event.target.result
                let image = document.createElement('img')
                image.src = imageUrl
                image.onload = (e) => {
                  let canvas = document.createElement('canvas')
                  canvas.width = image.width / 2
                  canvas.height = image.height / 2
                  const context = canvas.getContext('2d')
                  context.drawImage(image, 0, 0, canvas.width, canvas.height)
                  let newImageUrl = context.canvas.toDataURL('image/jpeg', 90)
                  let newImage = document.createElement('img')
                  newImage.src = newImageUrl
                  this.image = {
                    src: newImage.src,
                    type: this.getMimeType(reader.result, fileList[0].type)
                  }
                  this.isLoading = false
                }
              }
              this.errorMsg = null
              this.isImportShow = false
              EventBus.$on('moving', this.checkMoving)
              return
            }
            // passed
            this.errorMsg = null
            this.isImportShow = false
            this.loadImage(event)
          } else {
            this.errorMsg =
              'アップロードできるファイル形式は、PNG、JPG、JPEG、BMP、GIF形式です。'
          }
        } catch (error) {
          this.isLoading = false
          console.log(error)
        }
      } else {
        this.errorMsg = '複数ファイルを選択できません。'
      }
    },
    loadImage(event) {
      this.$emit('cropping-flag', true)
      // Reference to the DOM input element
      const { files } =
        event.type === 'change' ? event.target : event.dataTransfer
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src)
        }
        // Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0])

        // Create a new FileReader to read this image binary data
        const reader = new FileReader()
        reader.onload = e => {
          this.image = {
            src: blob,
            type: this.getMimeType(e.target.result, files[0].type)
          }
          this.isLoading = false
        }
        // Read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0])
        EventBus.$on('moving', this.checkMoving)
      }
    },
    getMimeType(file, fallback = null) {
      const byteArray = new Uint8Array(file).subarray(0, 4)
      let header = ''
      for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16)
      }
      switch (header) {
        case '89504e47':
          return 'image/png'
        case '47494638':
          return 'image/gif'
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
          return 'image/jpeg'
        default:
          return fallback
      }
    },
    change({ coordinates, image, canvas }) {
      this.$emit('no-close-modal', true)
    },
    cancel() {
      this.$emit('cancel', true)
    },
    crop() {
      this.$emit('is-loading', true)
      const { canvas } = this.$refs.cropper.getResult()
      // Extract with medium quantity option
      this.$emit('image-url', canvas.toDataURL('image/jpeg', 0.1))
    }
  },
  destroyed() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src)
    }
    EventBus.$off('moving', this.checkMoving)
  }
}
</script>

<style lang="scss" scoped>
.main-container {
  // Upload area
  .upload_area {
    position: relative;
    background: #fff;
    border-radius: 4px;
    border: 2px dashed #e5e5e5;
    text-align: center;
    margin: 40px 6px 6px 6px;
    p {
      @include responsive-fs(12);
      color: $base_text;
    }
    .btn_light_blue_round {
      width: 200px;
    }
    .drop {
      position: relative;
      top: 20px;
      img {
        width: 40px;
        margin-bottom: 20px;
      }
    }
  }
  .-drag {
    border: 2px dashed #e5e5e5;
    background: #f5f6f7;
  }
}
.crop-img-button {
  padding: 0.5em 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/AvatarUploadComponent.vue